import React from 'react';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import classnames from 'classnames';

import { useDrawerContext } from './context';
import style from './drawer-header.module.less';
import { IconButton } from '../button/icon-button';

/**
 * @typedef {import('./drawer-types.d.ts').DrawerHeaderType} DrawerHeaderType
 */

/**
 * @type {DrawerHeaderType}
 */
export const DrawerHeader = ({ className = '', closeButtonAriaLabel, title = null, titleClassName = '', actions = null }) => {
  const { onCancel } = useDrawerContext();
  return (
    <div className={classnames(style['header-wrapper'], className)}>
      <div className={classnames(style.title, titleClassName)}>{title}</div>
      <div className={style['close-wrapper']}>
        {actions}
        <IconButton ariaLabelMessageDescriptor={closeButtonAriaLabel} icon={faTimes} onClick={onCancel} />
      </div>
    </div>
  );
};
